import { Fragment, useState } from "react";
import Config from "../../../Config";
import InputComboRok from "../../../helpers/InputComboRok";
import InputComboMiesiac from "../../../helpers/InputComboMiesiac";
import InputLegend from "../../../helpers/InputLegend";
import InputTextAlpha from "../../../helpers/InputTextAlpha";
import InputPhone from "../../../helpers/InputPhone";
import InputPESEL from "../../../helpers/InputPESEL";
import InputText from "../../../helpers/InputText";


 
function Persons(props)
{


    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [row, setRowX] = useState({
        imie:  "",
        nazwisko: "",        
        nr_dowodu: "",        
        pesel: "",        
        pokrewienstwo: "",        
        numer_telefonu: "",                
    });
    var tmpRow = row;

    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);






    const valChecker = (fields) => {

        var allValid = true;
              
        //console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                // console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;
    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
        
 
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const saveData = () => {




        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

        var req = row;

        fetch( Config.url + '/rest_v1_parents,persons_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Osoba została dodana", "ok" , null);                         
                        setTab(null);


                        setRowX({
                            imie:  "",
                            nazwisko: "",        
                            nr_dowodu: "",        
                            pesel: "",        
                            pokrewienstwo: "",        
                            numer_telefonu: "",                
                        });

                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 


 

    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,persons', {
            method: 'POST', 
            body: JSON.stringify( {} ), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }





    const goDelete = (e) => 
        {        
            var id     = e.target.getAttribute("id");
            var title  = e.target.getAttribute("title");
    
            props.mainView.showDialog('Potwierdź' , "Na pewno chcesz usunąć: " + title + " ?" ,  "yesno"  , (param) => {
    
                            if(param != "yes") return;
    
                            props.mainView.setProgress(-2);
                            
                            var req  = {
                                id: id,
                            };
    
                                    fetch( Config.url + '/rest_v1_parents,persons_remove', {
                                        method: 'POST', 
                                        body: JSON.stringify(req), 
                                        headers: {
                                            'Content-Type': 'application/json',                    
                                            'X-Api-Key': props.userData.apiKey,
                                            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                            '_p_dziecko_id_': props.userData.p_dziecko_id,
                                            '_sec_key_': Config.genXKey() ,
                                        }
                                    })
                                    .then(res => res.json() )
                                    .then(res => {             
                                                
                                                props.mainView.setProgress(-1);
    
                                                if(res._sys_ == undefined)
                                                {
                                                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                                }else
                                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                {
                                                // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                                //setErrTab(res.result);
                                                }else
                                                if(res.status != undefined && res.status == "OK")
                                                {
                                                    props.mainView.showDialog( "Sukces",  "Uprawnienie dla wybranej osoby zostało usunięte.", "ok" , null);                        
                                                    setTab(null);                                               
                                                }else
                                                {
                                                    props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                                                }
                                            
                                    } )
                                    .catch(err => {   
                                                props.mainView.setProgress(-1);       
                                                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    });
    
            } ); 
    
        }
    



  

    
    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    







    return <div>
             

                        <div className="bg_center gocentermobile">
                          
                            <div className="calColor" >Ilość osób upoważnionych do odbioru dziecka: {tab.length}   </div>

                            <br/>
                                        <form className="eForm bg_center">

                                                    <div className="form_control">
                                                        <div className="fieldName">Imię*</div>
                                                        <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={""} className=' w100 ' req='1' firstUp="1" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nazwisko*</div>
                                                        <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={""} className=' w100 ' req='1' firstUp="1" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Telefon</div>
                                                        <InputPhone   userData={props.userData} value={row.numer_telefonu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="numer_telefonu" placeholder={""} className=' w100 ' req='0' firstUp="1" />
                                                    </div>

                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Pesel</div>
                                                        <InputPESEL   userData={props.userData} value={row.pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pesel" placeholder={""} className=' w100 ' req='0' firstUp="1" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nr dokumentu</div>
                                                        <InputText   userData={props.userData} value={row.nr_dowodu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_dowodu" placeholder={""} className=' w100 ' req='0' firstUp="1" />
                                                    </div>


                                                    <div className="form_control">
                                                        <div className="fieldName">Pokrewieństwo (Babcia, ciocia, ...)*</div>
                                                        <InputText   userData={props.userData} value={row.pokrewienstwo} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pokrewienstwo" placeholder={""} className=' w100 ' req='1' firstUp="1" />
                                                    </div>



                                                    <div className="form_split"></div>


                                                    <div className="form_btn">
                                                            <div className="btn" onClick={saveData}>dodaj osobę</div>                                                           
                                                    </div>

                                        </form>
                            <br/>


                            <ul className="parents_eat">

                                    
                                    {
                                        tab.map( (item, ix) => {

                                                return <li>

                                                            <div>
                                                                <span className="calColor"> {item.nazwisko} {item.imie}, nr dok. ****{item.nr_dowodu_4_ost_znaki}  </span> <sup className="link_bad"  onClick={goDelete}  id={item.id} title={ item.nazwisko + " " + item.imie} >usuń</sup>
                                                            </div>

                                                            <div>
                                                                dodano: {item.created_at} przez {item.dodal.nazwisko} {item.dodal.imie}
                                                            </div>

                                                </li>

                                        } )
                                    }    
                                    

                            </ul>   

                        </div>
 
    </div>
}


export default Persons;